import { render } from "./SideBarUser.vue?vue&type=template&id=0a691c7d"
import script from "./SideBarUser.vue?vue&type=script&lang=js"
export * from "./SideBarUser.vue?vue&type=script&lang=js"
script.render = render

export default script